import { useState } from "react";

interface AccordionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

export function Accordion({ title, children, defaultOpen = false }: AccordionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="accordion">
      <button
        className={`accordion-trigger${open ? " open" : ""}`}
        onClick={() => setOpen(!open)}
      >
        <span className="arrow">▶</span>
        {title}
      </button>
      <div className={`accordion-content${open ? " open" : ""}`}>
        <div className="accordion-inner">{children}</div>
      </div>
    </div>
  );
}
